
export default function Preparation() {
  const tips = [
    {
      icon: 'ri-file-list-line',
      title: 'Inventario previo',
      description: 'Haz una lista de los objetos que deseas conservar, donar o desechar para facilitar el proceso.'
    },
    {
      icon: 'ri-box-3-line',
      title: 'Objetos personales',
      description: 'Retira documentos importantes, joyas y objetos de valor sentimental antes del vaciado.'
    },
    {
      icon: 'ri-building-line',
      title: 'Aviso a la comunidad',
      description: 'Informa a la comunidad de vecinos sobre el día del vaciado para evitar molestias.'
    },
    {
      icon: 'ri-key-2-line',
      title: 'Acceso al inmueble',
      description: 'Asegúrate de tener las llaves disponibles y facilitar el acceso al equipo de trabajo.'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Suministros básicos',
      description: 'Verifica que haya luz y agua disponibles si se requiere limpieza posterior.'
    },
    {
      icon: 'ri-calendar-2-line',
      title: 'Planificación temporal',
      description: 'Reserva el servicio con antelación, especialmente en temporadas de alta demanda.'
    }
  ];

  return (
    <section id="preparacion" className="py-12 sm:py-16 md:py-20 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 px-2">
            Preparación del espacio
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto px-4">
            Sigue estos consejos para preparar tu piso antes del vaciado y asegurar un proceso rápido y sin complicaciones.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16">
          {tips.map((tip, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl p-6 sm:p-8 hover:bg-teal-50 transition-all duration-300 border-2 border-transparent hover:border-teal-200"
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-teal-600 rounded-lg flex items-center justify-center mb-4 sm:mb-6">
                <i className={`${tip.icon} text-2xl sm:text-3xl text-white`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3">
                {tip.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                {tip.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-teal-600 to-teal-700 rounded-xl sm:rounded-2xl p-6 sm:p-8 md:p-12 text-center text-white">
          <h3 className="text-xl sm:text-2xl md:text-3xl font-bold mb-3 sm:mb-4 px-2">
            ¿Necesitas Ayuda con la Preparación?
          </h3>
          <p className="text-base sm:text-lg text-teal-100 mb-6 sm:mb-8 max-w-2xl mx-auto px-4">
            Nuestro equipo puede asesorarte en todo el proceso. No dudes en consultarnos cualquier duda que tengas.
          </p>
          <a
            href="tel:629501941"
            className="inline-flex items-center gap-2 sm:gap-3 bg-white text-teal-600 px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-gray-50 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line text-lg sm:text-xl"></i>
            Llámanos: 629 501 941
          </a>
        </div>
      </div>
    </section>
  );
}
